function decodeStorefrontNodeId(storeFrontId: string): string {
  const str = atob(storeFrontId);
  const id = str.substring(str.lastIndexOf('/') + 1);
  return id;
}

export default decodeStorefrontNodeId;
